/**
 * @Description: vue模块引用
 * @Date: 2019-8-13
 * @Modify: 2019-08-14
 * @Author: kerong
 */

import space from './module/space'
import spacefilter from './module/spacefilter'
import upload from './module/upload'
import user from './module/user'
import sidebarData from './module/sidebarData'
import config from './module/config'
import database from './module/database'
import menus from './module/menus'
import members from './module/members'
import project from './module/project'

export default {
  space,
  config,
  database,
  menus,
  members,
  upload,
  spacefilter,
  user,
  sidebarData,
  project
}
